import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import { useLang } from "../context/LangContext";

export default function Company() {
  const { t } = useLang();

  return (
    <section id="company" className="py-24 md:py-32 bg-background border-b border-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="border border-border rounded-lg p-8 md:p-12 grid grid-cols-1 md:grid-cols-2 gap-10 items-start"
        >
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-foreground mb-2">
              {t.company.title}
            </h2>
            <p className="text-sm text-muted-foreground mb-8">
              {t.company.sub}
            </p>
            <a
              data-testid="astravion-link"
              href="http://astraviontech.com.br/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-border text-foreground font-medium px-5 py-2.5 rounded-md hover:bg-secondary active:scale-[0.98] transition-all duration-200 text-sm"
            >
              {t.company.cta}
              <ExternalLink size={14} />
            </a>
          </div>

          <p className="text-base text-muted-foreground leading-relaxed">
            {t.company.p}
          </p>
        </motion.div>
      </div>
    </section>
  );
}
